import styled from 'styled-components';

export const MarginBox = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  /*flex-direction: column;*/
  justify-content: center;

  @media screen and (max-width: 992px) {
    display: ${({ showAsStackInMobile }) => showAsStackInMobile == "true" ? "block" : "flex"};
  }
`;

export const MarginOverlapBox = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  min-height: 75vh;
  justify-content: center;
  position: relative;

  @media screen and (max-width: 992px) {
    display: ${({ showAsStackInMobile }) => showAsStackInMobile == "true" ? "block" : "flex"};
    min-height: 70vh;
  }

  @media screen and (max-width: 640px) {
    min-height: 65vh;
    width: 100%;
  }
`;

export const ContentBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 60px 0 60px 0;
  /*max-width: 604px;*/
  /*max-width: 850px;*/

  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    width: 100%;
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    width: 100%;
  }
`;

export const ContentOverlapBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 60px 0 60px 0;
  position: absolute;
  left: 0;

  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    width: 50%;
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    width: 100%;
  }
`;

export const OtherContentBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 60px 0 0 0;
  /*max-width: 604px;*/
  max-width: 70vw;

  @media screen and (max-width: 992px) {
    width: 100%;
    max-width: 80vw;    
    margin: 0;
  }
`;

export const SubContentBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 0 0 0 0;
  max-width: 604px;
  align-items: center;

  @media screen and (max-width: 992px) {
    width: 100%;
    margin: 0;
  }
`;

export const ImgBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  margin: 60px 0 60px 0;
  justify-content: space-between;
  
  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "block" : "none"};
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    display: none;
  }
`;

export const ImgMobileBox = styled.div`
  display: none;
  margin: 60px 0 60px 0;
  justify-content: space-between;
  
  @media screen and (max-width: 992px) {
    display: block;
    width: 100%;
  }
`;

export const ImageBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  /*margin: 0 auto;*/
  margin: 0 0 25vh 0;
  justify-content: space-between;
  
  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "block" : "none"};
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    /*display: none;*/
  }
`;

export const ImageOverlapBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  margin: 60px 0 60px 0;
  justify-content: space-between;
  position: absolute;
  right: 0;
  
  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "block" : "none"};
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    /*display: none;*/
    display: ${({ showInMobile }) => showInMobile == "true" ? "block" : "none"};
  }
`;

export const Image = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: ${({ minHeight }) => minHeight};
  background-image: url(${({ imageSrc }) => imageSrc});
  /*background-size: 100% 100%;*/
  background-size: contain;
  background-repeat: no-repeat;

  @media screen and (max-width: 1024px) {
    min-height: 40vh;
  }
  
  @media screen and (max-width: 992px) {
    min-height: 50vw;
    min-width: 80vw;
  }
`;

export const Img = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 40vh;
  background-image: url(${({ imageSrc }) => imageSrc});
  /*background-size: 100% 100%;*/
  background-size: contain;
  background-repeat: no-repeat;

  @media screen and (max-width: 1024px) {
    min-height: 40vh;
  }
  
  @media screen and (max-width: 992px) {
    min-height: 50vw;
    min-width: 80vw;
  }
`;

export const ImageOverlap = styled.div`
  display: flex;
  width: 100%;
  height: 80vh;
  min-height: 60vh;
  background-image: url(${({ imageSrc }) => imageSrc});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right center;

  @media screen and (max-width: 1024px) {
    min-height: 40vh;
  }
  
  @media screen and (max-width: 992px) {
    min-height: 30vh;
    min-width: 45vw;
    width: 100vw;
    background-position: -70px;
  }

  @media screen and (max-width: 425px) {
    background-size: 190%;
    background-position: center;
  }
`;


export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  margin : 0px 10px 20px 10px;

  h1.first {
    font-size: 36px;
    margin-bottom: 24px;
    color: #abc6de;

    @media screen and (max-width: 992px) {
      font-size: 32px;
    }

    @media screen and (max-width: 640px) {
      font-size: 28px;
    }
  }

  h1 {
    font-size: 36px;
    margin-bottom: 24px;
    color: #1B2555;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }

  p.green {
    font-size: 16px;
    line-height: 170%;
    color: #6AB644;
    font-weight: bold;

    /*@media screen and (max-width: 992px) {
      font-weight: 500;
    }*/
  }

  p {
    font-size: 16px;
    line-height: 170%;
    color: #585858;
    font-weight: 500;

    /*@media screen and (max-width: 992px) {
      font-weight: 500;
    }*/
  }

  span.first {
    font-size: 36px;
    color: #69b643;

    @media screen and (max-width: 992px) {
      font-size: 32px;
    }

    @media screen and (max-width: 640px) {
      font-size: 28px;
    }
  }

  span {
    font-size: 32px;
    color: #69b643;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }
`;
export const DesktopButton = styled.div`
  display: flex;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const MobileButton = styled.div`
  display: none;

  @media screen and (max-width: 992px) {
    display: flex;
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  color: ${({ color }) => color};
  margin: auto auto;
  max-width: 756px;
  font-weight: 500;
`;

export const Title = styled.h1`
  text-align: center;
  margin: ${({ margin }) => margin};
  font-size: 25px;
  color: #1b2555;
  font-weight: 700;

  @media screen and (max-width: 992px) {
    font-size: 18px;
  }
`;

export const TitleLabel = styled.h3`
  text-align: ${({ align }) => align};
  margin: ${({ margin }) => margin};
  line-height: 200%;
  font-size: 21px;
  color: #595959;
  font-weight: 700;
  /*max-width: 536px;*/

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

export const SubTitle = styled.h1`
  text-align: center;
  margin: ${({ margin }) => margin};
  font-size: 16px;
  color: #1b2555;
  font-weight: ${({ mini }) => mini === "true" ? 400 : 700};
  max-width: 756px;

  a {
  font-size: 16px;
  color: #1b2555;
  text-decoration: underline;
}

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

export const ListMember = styled.li`
  font-size: 16px;
  color: ${({ color }) => color};
  margin: auto auto;
  max-width: 671px;
  font-weight: 500;
`;

export const StripLeft = styled.div`
  display: flex;
  width: 1px;
  height: 177px;
  background-color: #69b643;
  margin: 15vh 0 0 25vw;

  @media screen and (max-width: 992px) {
    height: 128px;
    margin: 7vh 0 0 25vw;
    /*margin: -82px 0 0 40vw;*/
  }
`;

export const StripCenter = styled.div`
  display: flex;
  width: 1px;
  height: 256px;
  background-color: #69b643;
  margin: 84px 0 0 50%;

  @media screen and (max-width: 992px) {
    height: 128px;
    margin: 30px 0 5vh 50%;
  }
`;

export const StripRight = styled.div`
  display: flex;
  width: 1px;
  height: 256px;
  background-color: #69b643;
  margin: 0px 0 -10vh 56vw;

  @media screen and (max-width: 992px) {
    height: 128px;
    /*margin: -82px 0 0 40vw;*/
  }
`;